import { OptimizelySystemFeatureFlags } from './system-feature-flags';

export enum OptimizelyFeatureFlags {
    JJ_ADVISORY_MESSAGE_ENABLED = 'ace-83',
    MEMBERSHIP_TERMS_VISIBILITY = 'tcb-52',
    SHORTEN_MBT_PRICE_DRAW_TEST = 'tcb-54',
    SUPPORT_CENTRE_ENABLED = 'support_centre_enabled',
    AA_TEST = 'tcb-51',
    YOUR_PAYMENTS_BUTTON_VARIATIONS = 'tcb-45',
    PINO_TABLE_MBT_OPTIMIZATION = 'pino_table_mbt_optimization',
    MBT_PRICE_DRAWER_OPTIMISATION = 'tcb-69-mbt-price-drawer-optimisation',
    TCB65_MAP_V_NO_MAP = 'tcb65_map_v_no_map',
    MULTIPLE_ADD_ONS_PHASE_2_ENABLED = 'multiple_add_ons_phase_2_enabled',
    REBRANDING = 'rebranding',
    MULTIPLE_ADD_ONS_ENABLED = 'multiple_add_ons_enabled',
    PAYPAL_PAY_IN_3_GYM_BAG_IFRAME = 'paypal_pay_in_3_gym_bag_iframe',
    RETURN_USER_BASKET = 'return_user_basket',
    PRODUCT_TABLE_FREE_FREEZE_NOTICE = 'product_table_free_freeze_notice',
    PROMO_TILES_OPTIMIZATION = 'tcb-76-promo-tiles-optimisation',
    PAYPAL_PAY_IN_3_TABLE_IFRAME = 'paypal_pay_in_3_table_iframe',
    PAYPAL_PAY_IN_3_PRODUCT_OPTIONS = 'paypal_pay_in_3_product_options',
    GUEST_PASS_SLOTS_USAGE_ENABLED = 'guest_pass_slots_usage_enabled',
    GUEST_PASS_ENABLED = 'guest_pass_enabled',
    PAYMENT_IN_ARREARS = 'payment_in_arrears',
    REJOIN_JOURNEY = 'rejoin_journey',
    HEADLINE_RIBBON_ENABLED = 'headline_ribbon_enabled',
}

export type OptimizelyFlags =
    | OptimizelyFeatureFlags
    | OptimizelySystemFeatureFlags;
